export default function SectionIndex() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3 whitespace-nowrap">
            Index
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            主题索引
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          <a href="#ranking" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className="ri-fire-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">今日热搜</h3>
            <p className="text-xs text-foreground-500">实时更新的热度榜单</p>
          </a>

          <a href="#carousel" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className="ri-star-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">焦点专题</h3>
            <p className="text-xs text-foreground-500">深度策划的吃瓜特辑</p>
          </a>

          <a href="#cards" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className="ri-flashlight-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">独家爆料</h3>
            <p className="text-xs text-foreground-500">一手猛料速递</p>
          </a>

          <a href="#media" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className="ri-play-circle-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">吃瓜现场</h3>
            <p className="text-xs text-foreground-500">热门视频与盘点</p>
          </a>

          <a href="#topics" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className="ri-hashtag text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">话题标签</h3>
            <p className="text-xs text-foreground-500">按热度浏览话题</p>
          </a>

          <a href="#comments" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className="ri-chat-smile-2-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">群众热议</h3>
            <p className="text-xs text-foreground-500">吃瓜社区讨论区</p>
          </a>

          <a href="#updates" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className="ri-timer-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">最新快讯</h3>
            <p className="text-xs text-foreground-500">滚动更新的动态</p>
          </a>

          <a href="#faq" className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 hover:bg-background-50 no-underline cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className="ri-question-answer-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">吃瓜指南</h3>
            <p className="text-xs text-foreground-500">常见问题与解答</p>
          </a>
        </div>
      </div>
    </section>
  );
}